/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller
* # name: welcomeCtrl
* # alias: wCtrl
*/

export default class welcomeCtrl {
  constructor ($rootScope, $scope, $state, $stateParams, $timeout, $cookies, $interval) {
    this.$scope = $scope

    var getUserInfo = $interval(() => {
      $scope.adminName = $cookies.get('adminName')
      if ($scope.adminName) {
        $scope.roleName = $cookies.get('roleName')
        $interval.cancel(getUserInfo)
      }
    }, 500)

    this.$state = $state
    this.$timeout = $timeout
    this.$stateParams = $stateParams
    this.$cookies = $cookies
    this.$rootScope = $rootScope
    this.$rootScope.fullscreenClass = 'background-planning'
  }
}

welcomeCtrl.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$timeout', '$cookies', '$interval']



// WEBPACK FOOTER //
// ./src/welcome/welcomeCtrl.js